export default "__VITE_ASSET__94a73d48__"